import { FC } from "react";
import ReactApexChart from "react-apexcharts";

interface Props {
  color: string;
  chartData: any;
}
const ColumnChart2: FC<Props> = ({ chartData, color }) => {
  const series = [
    {
      name: "Servings",
      data: chartData,
    },
  ];
  const options: object = {
    chart: {
      width: "100%",
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    colors: [color],
    plotOptions: {
      bar: {
        borderRadius: 8,
        columnWidth: "15%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        },
      },
      padding: {
        top: 0,
        right: 20,
        bottom: 0,
        left: 30,
      },
    },
    yaxis: {
      show: false,
    },
    xaxis: {
      show: false,
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      tooltip: {
        enabled: false,
      },
      crosshairs: {
        show: false,
      },
    },
  };
  return (
    <ReactApexChart
      options={options}
      series={series}
      width="100%"
      type="bar"
      height={200}
    />
  );
};

export default ColumnChart2;
